import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox } from 'Components';
import './PickItem.css';

const PickItem = props => (
  <div className="pick-item">
    <CheckBox checked={props.checked} onClick={props.onClick} />
    <span>
      { props.title && <div className="pick-item__title">{props.title}</div> }
      <div>
        <span className="pick-item__subtitle">{props.subtitle}</span>
      </div>
      { props.hasChildren &&
        <i className={props.collapsed ? 'material-icons collapsed' : 'material-icons'}>arrow_drop_up</i>
      }
    </span>
  </div>);

PickItem.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  checked: PropTypes.bool,
  collapsed: PropTypes.bool,
  hasChildren: PropTypes.bool,
};

PickItem.defaultProps = {
  title: null,
  subtitle: null,
  checked: false,
  collapsed: true,
  hasChildren: false,
};

export default PickItem;



// WEBPACK FOOTER //
// ./src/components/PickItem/PickItem.jsx